export * from './validation';
export * from './dnd';
export * from './table';
export * from './reward';
export * from './dayjs';
export * from './map';
export * from './select';
export * from './object';
export * from './async';
export * from './id';
export * from './objectId';

export async function exportFile(blob: Blob, fileName: string): Promise<void> {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);

  window.URL.revokeObjectURL(objectUrl);
}
